module.exports = __webpack_public_path__ + "img/social-info3.83f0f84a.svg";